import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ClientJobView from 'components/JobView/ClientJobView';
import MatchesView from 'components/MatchesView/MatchesView';
import SidebarTabs from 'components/SidebarTabs/SidebarTabs';

import { useGetActiveSidebarItemId } from 'hooks/useGetActiveSidebarItemId';

import { SidebarTabsItem } from 'types/sidebar';

export const JOB_SIDEBAR_ITEMS_IDS = {
  JOB: 1,
  MATCHES: 2
};

interface JobSidebarProps {
  openItemId?: number;
}

const JobSidebar: FC<JobSidebarProps> = ({ openItemId }) => {
  const { t } = useTranslation();

  const allowedTabs = new Set<number>(Object.values(JOB_SIDEBAR_ITEMS_IDS));
  const activeItemId = useGetActiveSidebarItemId(allowedTabs, openItemId);

  const items: SidebarTabsItem[] = useMemo(
    () => [
      {
        id: JOB_SIDEBAR_ITEMS_IDS.JOB,
        title: t('sidebar.job.tab.info'),
        component: <ClientJobView />
      },
      {
        id: JOB_SIDEBAR_ITEMS_IDS.MATCHES,
        title: t('sidebar.job.tab.matches'),
        component: <MatchesView />
      }
    ],
    []
  );

  return (
    <div>
      <SidebarTabs
        items={items}
        isChangeCurrentTabOnNewItems={false}
        openItemId={activeItemId}
      />
    </div>
  );
};

export default JobSidebar;
